import './ResultHeader.style.css'

function ResultHeader() {
  return (
    <div>
      <h2>Search Results</h2>
    </div>
  )
}

export default ResultHeader
